import amplitude from 'amplitude-js';
import { amplitudeKey } from 'config/config';
import { getUserId } from './local-data-provider';

class AmplitudeService {
  constructor() {
    this.isInit = false;
  }

  init = () => {
    amplitude.getInstance().init(amplitudeKey);
    this.isInit = true;
  };

  track = (name, properties = {}, callback) => {
    if (!this.isInit) this.init();
    amplitude.getInstance().setUserId(getUserId());
    amplitude.getInstance().logEvent(name, properties, callback);
  };
}

export default AmplitudeService;
